import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReturnNotificationCheckbox from './ReturnNotificationCheckbox';
export default class ReturnNotificationCheckboxes extends PureComponent {
  openModal = modalUrl => {
    const {
      openModal
    } = this.props;
    openModal(modalUrl);
  };
  render() {
    const {
      refundNotifications,
      clickOnNotificationCheckbox
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "order-return__compliance-notification-checkboxs"
    }, refundNotifications.map(notification => {
      const {
        position
      } = notification;
      return /*#__PURE__*/React.createElement(ReturnNotificationCheckbox, {
        ...notification,
        key: position,
        openModal: this.openModal,
        onClick: clickOnNotificationCheckbox
      });
    }));
  }
}
ReturnNotificationCheckboxes.propTypes = {
  openModal: PropTypes.func,
  clickOnNotificationCheckbox: PropTypes.func,
  refundNotifications: PropTypes.arrayOf(PropTypes.shape({
    position: PropTypes.number,
    type: PropTypes.string,
    isChecked: PropTypes.bool,
    modalUrl: PropTypes.string
  }))
};